import React, {Component} from "react";

import { IS_VALID }       from "utils";

import Create             from "./Create";
import View               from "./View";

export default class FormContainer extends Component {
    render () {
        let {
            actions,

            selectedData,
            formType,

            visibilityOptions
        } = this.props;

        let createProps = {
            actions
        };

        let viewProps = {
            selectedData,

            visibilityOptions
        };

        switch (formType.toUpperCase()) {
            case "UPDATE":
            case "CREATE":
                return <Create {...createProps} />;
                break;
            case "VIEW":
                return <View {...viewProps} />;
                break;
            case "DELETE":
                return (
                    <p>
                      Are you sure you want to delete&nbsp;
                      {IS_VALID(selectedData) && IS_VALID(selectedData.get("title")) ? (
                        <span style={{ color: "red" }}>{selectedData.get("title")}</span>
                      ) : (
                        "this data"
                      )}
                      ?
                    </p>
                );
                break;
            default:
                return "";
                break;
        }
    }

    componentWillUnmount () {
        let {
            actions
        } = this.props;

        actions.setValue({
            selectedData: null,
            formType: "",
            formId: "",
            formTitle: "",

            image: null,
            browser: null,
            url: "",
            sort: "",
            isEasyPromos: false,
            promoId: "",
            visibilityType: {
                label: 'Always On',
                value: 'AO'
            },
            visibilityStartTime: '',
            visibilityEndTime: '',
            campaignStartDate: '',
            campaignEndDate: ""
        });
    }
}


// WEBPACK FOOTER //
// ./components/LifestyleBanner/FormContainer/index.js